/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Blood pressure card
 */

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FrownFilled, HeartFilled, SmileFilled } from '@ant-design/icons';
import { groupBy } from 'lodash';

// Helpers
import { BLOOD_PRESURE_INDICATOR } from '@nephro/pages/Indicators/helpers/constants';
import {
  sortNumber,
  sortByDate,
  bloodPressureValidation
} from '@nephro/commons/helpers/utils';

// Hooks
import usePatientIndicators from '@nephro/pages/Indicators/helpers/usePatientIndicators';

import DashboardPatientCard from '../dashboardPatientCard';

const footerIconStyle = { fontSize: 25, color: 'white' };

const BloodPressureCard = () => {
  const { t: translate } = useTranslation();
  const bloodPressureData = usePatientIndicators(BLOOD_PRESURE_INDICATOR);
  const [data, setData] = useState(null);

  const title = translate('dashboardPatient.bloodPressureTitle');

  const getFooterValue = (bloodPressure, bpState) => {
    const icon =
      bpState !== 'normal' ? (
        <FrownFilled style={footerIconStyle} />
      ) : (
        <SmileFilled style={footerIconStyle} />
      );
    return {
      text: bloodPressure,
      icon
    };
  };

  const sortByDatesArray = (list, mode = 'desc') =>
    list.sort((a, b) => {
      const result =
        mode === 'desc' ? new Date(b) - new Date(a) : new Date(a) - new Date(b);
      return result;
    });

  useEffect(() => {
    if (bloodPressureData?.length) {
      bloodPressureData?.sort(sortNumber('valor'));
      const bpData = sortByDate(bloodPressureData, 'fecha');

      const groupByDates = groupBy(bpData, 'fecha');

      const datesArray = sortByDatesArray(Object.keys(groupByDates), 'asc');

      const lastDate = datesArray[datesArray.length - 1];
      const [low, high] = groupByDates[lastDate];
      const bpState = bloodPressureValidation(high.valor, low.valor);

      const footer = getFooterValue(`${high.valor}/${low.valor}`, bpState);
      const componentData = {
        title,
        link: 'blood-presure',
        mainIcon: <HeartFilled style={{ fontSize: 40, color: 'white' }} />,
        footer,
        background: 'bg-cardPurple'
      };
      setData(componentData);
    }
  }, [title, bloodPressureData]);

  return <DashboardPatientCard data={data} />;
};

export default BloodPressureCard;
